import classNames from "classnames";
import React from "react";

export type SpinnerComponentProps = {
    color?:
        | "primary"
        | "secondary"
        | "success"
        | "danger"
        | "warning"
        | "info"
        | "light"
        | "dark";
    size?: "sm" | "md" | "lg";
    className?: string;
    type?: "border" | "grow";
    children?: React.ReactNode;
};

const Spinner = ({
    color,
    size,
    type = "border",
    className,
    children,
}: SpinnerComponentProps) => {
    const classes = classNames(
        className,
        size ? `spinner-${type}-${size}` : false,
        `spinner-${type}`,
        color ? `text-${color}` : false,
    );

    return (
        <div role="status" className={classes}>
            {children && <span className="sr-only">{children}</span>}
        </div>
    );
};

export { Spinner };
